import { DependenciesInjection } from "app/di/DependencyInjection";
import { UserPermissionImpl } from "../data/UserPermissionImpl";
import { IUserPermissionRepository } from "../domain/repositories/IUserPermissionRepository";
import { UserPermissionUseCase } from "../domain/useCases/UserPermissionUseCase";
import { UserPermissionViewModel } from "../presentation/viewModel/UserPermissionViewModel";
import { UserPermissionToken } from "./UserPermissionToken";

export class UserPermissionInjection {
  static initInjections() {
    DependenciesInjection.register<IUserPermissionRepository>(
      UserPermissionToken.IUserPermissionRepository,
      UserPermissionImpl,
      "otherRepo",
    );
    DependenciesInjection.register<UserPermissionUseCase>(
      UserPermissionToken.UserPermissionUseCase,
      UserPermissionUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<UserPermissionViewModel>(
      UserPermissionToken.UserPermissionViewModel,
      UserPermissionViewModel,
      "viewModel",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<IUserPermissionRepository>(
      UserPermissionToken.IUserPermissionRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<UserPermissionUseCase>(
      UserPermissionToken.UserPermissionUseCase,
    );
  }
}
